// El archivo HistorySidebar estaba vacío desde el primer commit y App.tsx
// lo importa. Stub mínimo para que compile — la vista histórica no está
// habilitada hoy (no aparece en la navegación desde que el sidebar Fase B
// removió "Buscar alumno" y "Nuevo piloto"). Cuando se reactive esta vista
// habrá que decidir su diseño desde cero.
import type { SessionListItem } from '../types';

import type { Modality } from '../types';

export interface HistoryFilters {
  q?: string;
  status?: 'open' | 'closed' | 'reviewed';
  modality?: Modality;
  oaQuery?: string;
}

interface HistorySidebarProps {
  sessions: readonly SessionListItem[];
  total: number;
  page: number;
  pageSize: number;
  filters: HistoryFilters;
  onOpen: (sessionId: string) => void;
  onFiltersChange: (filters: HistoryFilters) => void;
  onPageChange: (page: number) => void;
  isLoading: boolean;
}

export function HistorySidebar(_props: HistorySidebarProps) {
  return null;
}
